<template>
  <div class="order-detail">
    <div class="detail-box">
      <div class="detail-title">基本信息</div>
      <div class="detail-item">
        <span class="label">投保时间</span>
        <span class="text1">{{ renewalDetail.insureTime | formatTime('YYYY-MM-DD HH:mm') }}</span>
      </div>
      <div class="detail-item">
        <span class="label">保障期限</span>
        <span class="text1">{{ renewalDetail.startTime | formatTime('YYYY-MM-DD') }}至{{ renewalDetail.endTime | formatTime('YYYY-MM-DD') }}</span>
      </div>
      <div class="detail-item">
        <span class="label">保费</span>
        <span class="text1">{{ renewalDetail.fee }}元</span>
      </div>
    </div>
    <div class="detail-box">
      <div class="detail-title">投保人</div>
      <div class="detail-item">
        <span class="label">名称</span>
        <span class="text1">{{ renewalDetail.holderName || '—' }}</span>
      </div>
      <div class="detail-item">
        <span class="label">证件号码</span>
        <span class="text1">{{ renewalDetail.holderCardNo || '—' }}</span>
      </div>
      <div class="detail-item">
        <span class="label">地址</span>
        <span class="text1">{{ renewalDetail.holderAddress || '—' }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import {
	common
} from "@/api/mixins";
export default {
  mixins: [common],
  props: {
    renewalDetail: null,
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
</style>
